import React, { Component } from "react";
import axios from "axios";
import ConfigData from "../Components/config";

export default class Checklogin extends Component {
  componentDidMount() {
    axios
      .get(
        ConfigData.SERVER_URL +
          "FrontEnd_Tabian/Login/CheckLoginRubrong/" +
          this.props.match.params.id
      )
      .then((res) => {
        if (res.data.data.length !== 0) {
          if (res.data.data[0]["checkstatus"] === "student") {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("id", this.props.match.params.id);
            localStorage.setItem("checkstatus", "student");
            localStorage.setItem("name", res.data.data[0].PNAME + res.data.data[0].NAME);
            axios
              .get(
                ConfigData.SERVER_URL +
                  "FrontEnd_Tabian/petition/ShowReportPetition/" +
                  this.props.match.params.id
              )
              .then((ShowReportPetition) => {
                if (ShowReportPetition.data.length !== 0) {
                  window.location.href = "/rubrongkpru/Datarubrong";
                } else {
                  window.location.href = "/rubrongkpru/Addpetition";
                }
              });
          } else if (res.data.data[0]["checkstatus"] === "teacher") {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("id", this.state.Username);
            localStorage.setItem("checkstatus", "teacher");
            localStorage.setItem("name", res.data.data[0].prenm + res.data.data[0].poname);
            localStorage.setItem("shortname", res.data.data[0]["name"]);
            if (res.data.data[0]["name"] === "ฆัมภิชา") {
              window.location.href = "/rubrongkpru/ShowcertificateVicerector";
            }
             else if (res.data.data[0]['name'] === "จิรพงค์" ) { 
              // || res.data.data[0]['name'] === "วันวิสา"
                window.location.href = '/rubrongkpru/ShowcertificateHeadtabian';
            }
            else {
              window.location.href = "/rubrongkpru/ShowcertificateTeacher";
            }
          } else if (res.data.data[0]["checkstatus"] === "tabian") {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("id", res.data.data[0]["citizent"]);
            localStorage.setItem("checkstatus", "tabian");
            localStorage.setItem(
              "name",
              res.data.data[0].prename_admin +
                res.data.data[0].name_admin +
                "  " +
                res.data.data[0].lname_admin
            );
            localStorage.setItem("shortname", res.data.data[0].name_admin);
            if (res.data.data[0].name_admin === "ผดุงพร") {
              window.location.href = "/rubrongkpru/ShowcertificateHeadtabian";
            } else {
              window.location.href = "/rubrongkpru/Showcertificate";
            }
          }
        } else {
          window.location.href = "/rubrongkpru";
        }
      })
      .catch((err) => {
        window.location.href = "/rubrongkpru";
      });
  }

  render() {
    return <></>;
  }
}
